import { TrackedChange } from 'models/changes'
import { useCallback, useEffect, useRef } from 'react'
import { CellMeasurerCache } from 'react-virtualized'

export const useTrackChangesCache = (changes: TrackedChange[]) => {
    const cacheRef = useRef(
        new CellMeasurerCache({ defaultHeight: 200, fixedWidth: true })
    )

    const setCacheHeight = useCallback((height: number, row: number) => {
        const cache = cacheRef.current
        cache.set(row, 0, cache.getWidth(row, 0), height)
    }, [])

    // Clear cache and re-measure the properties after state change
    const clearCacheRow = useCallback((row: number) => {
        cacheRef.current.clear(row, 0)
    }, [])

    useEffect(() => {
        cacheRef.current.clearAll()
    }, [changes])

    return { cache: cacheRef.current, setCacheHeight, clearCacheRow }
}
